<template>
  <DBox
    :id="'cmp-licence_licence-account-sidewindow-licences'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('Related Licence')}`"
    @add_click="onAddRelatedTracks"
    :noSeparator="true"
  >
    <NTable
      class="dbox1"
      id="licence-licence_account-sidewindow-licences"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
      @scrollnext="onScroll"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td @click="onReleatedLicenceClick(item)" v-bind="tdcon('licences')">
            <span
              style="white-space: break-spaces"
              class="ut-link ut-text-accent5"
              >{{ item["licence"] }}</span
            >
          </td>
          <td v-bind="tdcon('type')">
            <span style="white-space: break-spaces">{{
              $t(item["asset_type"])
            }}</span>
          </td>
          <td v-bind="tdcon('start_end')">
            <span
              ><template v-if="item['start_date']">{{
                item["start_date"]
              }}</template>
              <template v-if="item['end_date']">
                / {{ item["end_date"] }}</template
              ></span
            >
          </td>
          <td v-bind="tdcon('active')">
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1">
                <input
                  class="disabled"
                  type="checkbox"
                  :name="'active_flag'"
                  :id="'active_flag'"
                  :checked="item['active_flag'] == 1"
                  @click="e => onCheckBoxChange(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('repertoire')">
            <span
              style="white-space: break-spaces"
            >{{ item['assets'] }}</span>
          </td>
          <td v-bind="tdcon('last_statement')">
            <span>{{ item["last_statements"] }}</span>
          </td>
          <td v-bind="tdcon('income')">
            <span>{{ item["income"] }}</span>
          </td>
          <td v-bind="tdcon('duplicate')">
            <img
              @click.stop="e => duplicateLicence(item)"
              src="static/icons/double-plus.svg"
              class="dt-icon v5 s2 ut-center"
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
            v-if="parseInt(item['show_delete'])!==0"
              @click.stop="e => deleteLicence(item)"
              src="static/icons/delete.svg"
              class="dt-icon v5 s2 ut-center"
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { licencesListLDTRoutes } from "../../router/routes";
import { addRemoveSet } from "../../../../utility";
import { Subject } from "rxjs";
import { licenceAccountsService } from "../../services/licence-accounts.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
export default {
  props: {
    selectedLicenceAccountDetails: {
      type: Object
    },
    licence_account_id:{
      type:Number
    }
  },
  components: {
    NTable,
    DBox
  },
  mounted: async function () {

    subscribeSubject(this, this.scrollSubject, scrollTop => {
        this.row_start+=100;
        this.row_count+=100;
        licenceAccountsService.licenceAccountRelatedLicences(this.licence_account_id,this.row_start,this.row_count).then(res=>{
          this.$emit("scroll",{ licence_account_id:this.licence_account_id ,licenceList:res.data.licences })
        });
    });
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: "auto",
        headerHeight: 32,
        fullHeight: true
      }),
      row_start:0,
      row_count:100,

      selectedLicenceLines: new Set(),
      scrollSubject: new Subject(),
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("licences", { f: 1.7 }),
        createTableHeader("type", { f: 1.2 }),
        createTableHeader("start_end", { f: 1.5, mw: 164, minw: 164 }),
        createTableHeader("active", { mw: 60 }),
        createTableHeader("repertoire", { f: 1.3 }),
        createTableHeader("last_statement", { f: 1.3 }),
        createTableHeader("income", {
          f: 0.8,
          text: `${this.$t("income")} ${
            this.$store.getters.account.client.default_currency
          }`,
          ta: "right"
        }),
        createTableHeader("duplicate", { text: false, mw: 30 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedLicenceAccountDetails.licences || [];
    },
    firstHeaderText: function() {
      return this.list.length > 0 ? this.$t("not_yet_invoiced") : "licences";
    }
  },

  methods: {
    getRepotireString: function(item) {
      return item
        .map(e => {
          return `${e.artist?e.artist:''} ${e.title?e.title:''} ${e.version?e.version:''} ,`;
        })
        .join("").replace(/,*$/, "");;
    },
    duplicateLicence: function(item) {
      console.log("ITEM", item);
      this.$router.push({
        ...this.$route,
        query: {
          modal: "duplicate_licence",
          licence_id: item.licence_id,
          licence_account_id: this.licence_account_id
        }
      });
    },
    onReleatedLicenceClick: function(item) {
      this.$router.push({
        name: licencesListLDTRoutes.names.tab,
        params: {
          licence_id: item.licence_id,
          tab: "overview"
        }
      });
    },
    onCheckBoxChange: function(e, item) {
      this.selectedLicenceLines = addRemoveSet(
        e.target.checked,
        this.selectedLicenceLines,
        item.licence_line_id
      );

      this.$emit('update',{item:{...item,licence_account_id:this.licence_account_id},value:e.target.checked?1:0})
    },
    deleteLicence:async function(item) {
      const confirmationResult = await confirmDelete(
        "following licence",
        item.licence
      );

      if (confirmationResult === "OK") {
        this.$emit("delete", {
          licence_id: item.licence_id,
          licence_account_id: this.licence_account_id
        });
      }
      
    },
    onAddRelatedTracks: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "create_licence_form",
          licence_account_id: this.licence_account_id
        }
      });
    },
    onScroll:function(value){
      this.scrollSubject.next(value);
    }
  }
};
</script>
<style lang="scss">
.cmp-licence_licence-account-sidewindow-licences {
  // .dt-ntable {
  //   --ntable-height: 170px;
  // }
}
</style>
